import { API } from "@/constants/common";
import { apiClient } from "../client/apiClient";

export class CampaignService {
  static instance: CampaignService;

  public static QUERY_KEY = {
    BASE: "campaign",
    FETCH_ALL: ["campaign", "fetch_all"],
  };

  constructor() {
    if (CampaignService.instance) {
      return CampaignService.instance;
    }
    CampaignService.instance = this;
  }

  async getCampaignList(params: any): Promise<any> {
    const { data } = await apiClient.get(API.CAMPAIGN.LIST, {
      ...params,
    });
    return data;
  }

  async getCampaignDetail(id: string): Promise<any> {
    const data = await apiClient.get(API.CAMPAIGN.DETAIL(id));
    return data;
  }

  async createCampaign(params: any): Promise<any> {
    const data = await apiClient.post(API.CAMPAIGN.CREATE, params);
    return data;
  }

  async updateCampaign(id: string, params: any): Promise<any> {
    const data = await apiClient.put(API.CAMPAIGN.UPDATE(id), params);
    return data;
  }

  async getCampaignParams(type: string): Promise<any> {
    const data = await apiClient.get(API.CAMPAIGN.FETCH_CAMPAIGN_PARAMS(type));
    return data;
  }

  async copyCampaign(id: string | number): Promise<any> {
    const data = await apiClient.post(API.CAMPAIGN.COPY_CAMPAIGN(id));
    return data;
  }

  async switchStatus(params: { id: number; status: string }): Promise<any> {
    const data = await apiClient.patch(API.CAMPAIGN.UPDATE_STATUS, {
      id: params.id,
      status: params.status,
    });
    return data;
  }

  async downloadReport(campaignId): Promise<any> {
    const data = await apiClient.get(API.CAMPAIGN.DOWNLOAD_REPORT(campaignId));
    return data;
  }
}
